import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Navbar from "../Navbar";
// import { useDispatch } from "react-redux";
const SERVER_URL = process.env.REACT_APP_SERVER_URL

// import Form from "../form";
// import "../form.css";
// import Login from "./temp";

// Primitive arguments


const SignIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  // const [token, setToken] = useState("");
  // const [redirect, setRedirect] = useState(
  //   localStorage.getItem("userTokenTime")
  // );

// const dispatch = useDispatch()

  const onSubmitHandler = (e) => {
    if (
      !(email === "" || password === "") &&
      // eslint-disable-next-line
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)
    ) {
      axios
        .post(SERVER_URL+"/api/signin", {
          email: email,
          password: password,
        })
        .then((res) => {
          console.log(res.data);
          // setToken(res.data.token);
          const data = {
            token: res.data.token,
            time: new Date().getTime(),
          };
          localStorage.setItem("userTokenTime", JSON.stringify(data));
          localStorage.setItem("productsInCart", JSON.stringify(res.data.cart));
          localStorage.setItem("role", JSON.stringify(res.data.role));
          localStorage.setItem("userName", JSON.stringify(res.data.firstName));
          localStorage.setItem("shippingAddresses", JSON.stringify(res.data.shippingAddresses));
          localStorage.setItem("email", JSON.stringify(res.data.email));
          
          // dispatch({ type: "LOAD_CART" });
          // setRedirect(true);
          // if(res.data.role==="user")
          window.location = "https://store-18.netlify.app/"
          // else if(res.data.role==="admin")
          // window.location = "http://localhost:3000/admin/"

        })
        .catch((err) => {
          console.log(err);
        });

        

    } else {
      alert("Please enter valid details");
    }
  };
  // if (redirect) return <Navigate to="/" />;
  return (
    <div>
      <Navbar/>
      <form 
      id="login-form"
      className="form form-section"
        method="post"
        onSubmit={(e) => onSubmitHandler(e)}>
        <h3 className="mx-3" style={{ color: "#00ADEF" }}>
          Login
        </h3>
        <p className="mx-3">Get access to your Orders, Wishlist and Recommendations</p>

        <div className="form-group mx-3">
          <label htmlFor="email" style={{ color: "#00ADEF" }}>
            Email:
          </label>
          <input
            id="email"
            className="form-control"
            type="email"
            name="email"
            placeholder="example@domain.com"
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="form-group mx-3">
          <label htmlFor="password" style={{ color: "#00ADEF" }}>
            Password:
          </label>
          <input
            id="password"
            className="form-control"
            type="password"
            name="password"
            placeholder="********"
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <p className="mx-3 ">By continuing, you agree to Store's Terms of Use and Privacy Policy.</p>

        {/* <div className="d-flex justify-content-between align-items-end"> */}
        <div className=" d-grid mx-3">
          <button
            onClick={(e) => onSubmitHandler(e)}
            className="btn btn-md mt-2"
            style={{ backgroundColor: "#00ADEF", color: "white" }}
            type="button"
          >
            Log in
          </button>
        </div>
        <div className="mx-3 mt-3">
          <div className="d-flex justify-content-center">
            <p className="login-p">Don't have an account? &nbsp; </p>
            <Link
              to="/signup"
              style={{
                color: "#00ADEF",
                textDecoration: "none",
                background: "none",
              }}
            >
              Sign up
            </Link>
          </div>
          <div className="d-flex justify-content-center mt-1">
            <Link
              to="/login/forgetpassword"
              style={{
                color: "#00ADEF",
                textDecoration: "none",
                background: "none",
              }}
            >
              Forgot password?
            </Link>
          </div>
        </div>
      </form>
    </div>
  );
};

// class SignIn extends React.Component {
//   constructor(props) {
//     super(props);

//     this.state = {
//       email: "",
//       password: "",
//       token: "",
//       isResetting: localStorage.getItem("isResetting")==="true",
//       redirect: localStorage.getItem("userTokenTime") ? true : false,
//     };

//     this.onSubmitHandler = this.onSubmitHandler.bind(this);
//     this.emailInputChangeHandler = this.emailInputChangeHandler.bind(this);
//     this.passwordInputChangeHandler =
//       this.passwordInputChangeHandler.bind(this);
//   }

// onSubmitHandler() {
//   if (
//     !(this.state.email === "" || this.state.password === "") &&
//     // eslint-disable-next-line
//     /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
//       this.state.email
//     )
//   ) {
//     axios
//       .post("/api/signIn", {
//         email: this.state.email,
//         password: this.state.password,
//       })
//       .then((res) => {
//         this.setState({
//           token: res.data.token,
//         });
//         const data = {
//           token: this.state.token,
//           time: new Date().getTime(),
//         };
//         localStorage.setItem("userTokenTime", JSON.stringify(data));
//         this.setState({
//           redirect: true,
//         });
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//   } else {
//     alert("Please enter valid details");
//   }
// }

//   emailInputChangeHandler(event) {
//     this.setState({
//       email: event.target.value,
//     });
//   }

//   passwordInputChangeHandler(event) {
//     this.setState({
//       password: event.target.value,
//     });
//   }

//   render() {
//     console.log(localStorage.getItem("isResetting"));
//     if (this.state.redirect) return <Navigate to="/" />;
//     return (
//       <div>
//         <Form onSubmit={this.onSubmitHandler.bind(this)}>
//           <h3 className="mx-3" style={{ color: "#00ADEF" }}>
//             Log in
//           </h3>
//           <p className="mx-3">Login to create and upload videos</p>

//           {/* {this.state.isResetting? <p>hi</p>:<></>} */}
//           <div className="form-group mx-3">
//             <label htmlFor="email" style={{ color: "#00ADEF" }}>
//               Email:
//             </label>
//             <br />
//             <input
//               id="email"
//               className="form-control"
//               type="email"
//               name="email"
//               placeholder="example@domain.com"
//               onChange={this.emailInputChangeHandler}
//               required
//             />
//           </div>
//           <div className="form-group mx-3">
//             <label htmlFor="password" style={{ color: "#00ADEF" }}>
//               Password:
//             </label>
//             <br />
//             <input
//               id="password"
//               className="form-control"
//               type="password"
//               name="password"
//               placeholder="********"
//               onChange={this.passwordInputChangeHandler}
//               required
//             />
//           </div>
//           {/* <div className="d-flex justify-content-between align-items-end"> */}
//           <div className=" d-grid mx-3">
//             <button
//               onClick={this.onSubmitHandler}
//               className="btn btn-md mt-2"
//               style={{ backgroundColor: "#00ADEF", color: "white" }}
//               type="button"
//             >
//               Log in
//             </button>
//           </div>
//           <div className="mx-3 mt-3">
//             <div className="d-flex justify-content-center">
//               <p className="login-p">Don't have an account? &nbsp;  </p>
//               <Link
//                 to="/signUp"
//                 style={{
//                   color: "#00ADEF",
//                   textDecoration: "none",
//                   background: "none",
//                 }}
//               >
//                  Sign up
//               </Link>
//             </div>
//             <div className="d-flex justify-content-center mt-1">
//               <Link
//                 to="/login/forgetpassword"
//                 style={{
//                   color: "#00ADEF",
//                   textDecoration: "none",
//                   background: "none",
//                 }}
//               >
//                 Forgot password?
//               </Link>
//             </div>
//           </div>
//         </Form>
//       </div>
//     );
//   }
// }

export default SignIn;